import React from "react"
import { type ConnectedProps, connect } from "react-redux"
import { Navigate } from "react-router-dom"

import { RoutesPaths } from "../../constants/routes.ts"
import { type RootState } from "../../store"

interface PrivateRouteProps extends ConnectedProps<typeof connector> {
  children: React.ReactNode
  redirectTo?: string
}

function PrivateRoute({
  children,
  auth,
  userInfo,
  isAdmin,
  redirectTo = RoutesPaths.auth.login
}: PrivateRouteProps) {
  const isAuthorized = !!auth?.accessToken && !!userInfo && !isAdmin

  if (!isAuthorized) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
  userInfo: state.auth.userInfo,
  isAdmin: state.auth.isAdmin
})

const connector = connect(mapStateToProps)
export default connector(PrivateRoute)
